import { createContext, useCallback, useContext, useMemo } from "react";

import { linkBranchToRegionQuery } from "./queries";

const BranchPerRegion = createContext({});

export const useBranchPerRegionContext = () => useContext(BranchPerRegion);

export const BranchPerRegionProvider = ({ ...props }) => {
  const linkBranchToRegion = useCallback(async (data) => {
    try {
      await linkBranchToRegionQuery(data);
    } catch (e) {
      console.error("getTemplatesList", e);
    }
  }, []);

  const values = useMemo(
    () => ({
      linkBranchToRegion,
    }),
    [linkBranchToRegion]
  );
  return <BranchPerRegion.Provider value={values} {...props} />;
};
